var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2668 5.75H19.7335L15.3501 14.5H24.6501L20.2668 5.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4335 14.5H36.0335L31.6668 5.75H23.0668L27.4335 14.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6335 17H21.2501V34.25L35.6335 17Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7501 34.25V17H4.3668L18.7501 34.25Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5668 14.5L16.9335 5.75H8.33346L3.9668 14.5H12.5668Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondIcon);
export default __webpack_public_path__ + "static/media/diamond_icon.577df837.svg";
export { ForwardRef as ReactComponent };